document.addEventListener('DOMContentLoaded', function() {
    // Function to handle smooth scrolling
    function smoothScroll(target) {
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }

    // Check if there's a hash in the URL
    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        if (target) {
            // Prevent the automatic scroll
            window.scrollTo(0, 0);

            // Delay the scroll to ensure all content is loaded
            setTimeout(function() {
                smoothScroll(target);
            }, 100);
        }
    }

    // Add click event listeners to all smooth-scroll-link elements
    const smoothScrollLinks = document.querySelectorAll('.smooth-scroll-link');
    smoothScrollLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href && href.startsWith('#')) {
                e.preventDefault();
                const targetId = href.slice(1);
                const target = document.getElementById(targetId);
                if (target) {
                    smoothScroll(target);
                    // Update the URL without triggering a page reload
                    history.pushState(null, '', href);
                }
            }
        });
    });
});